var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1338 58H17.75L35 40.75L40.405 46.155C42.1875 43.3375 44.66 41.0375 47.65 39.6L52.25 35V38.1338C53.1988 37.99 54.1475 37.875 55.125 37.875C56.1025 37.875 57.0512 37.99 58 38.1338V23.5L40.75 6.25H17.75C14.5587 6.25 12 8.80875 12 12V58C12 59.525 12.6058 60.9875 13.6841 62.0659C14.7625 63.1442 16.225 63.75 17.75 63.75H40.2038C39.1975 61.9962 38.4788 60.07 38.1338 58ZM37.875 10.5625L53.6875 26.375H37.875V10.5625ZM23.5 26.375C25.025 26.375 26.4875 26.9808 27.5659 28.0591C28.6442 29.1375 29.25 30.6 29.25 32.125C29.25 33.65 28.6442 35.1125 27.5659 36.1909C26.4875 37.2692 25.025 37.875 23.5 37.875C20.3087 37.875 17.75 35.3163 17.75 32.125C17.75 28.9337 20.3375 26.375 23.5 26.375ZM58 43.625V52.25H66.625V58H58V66.625H52.25V58H43.625V52.25H52.25V43.625H58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadLogo);
export default __webpack_public_path__ + "static/media/file-upload-logo.83930afbf0116b4f52ddc82b8be3016e.svg";
export { ForwardRef as ReactComponent };